/**
 * Sticky gallery for mobile PDP (treatment only).
 *
 * Moves the collection portal into the gallery's container so they share
 * the same parent. The gallery is position:sticky within that parent,
 * naturally unsticking when the portal (below it) scrolls past.
 *
 * The html/body overflow this relies on now lives in custom.css.liquid
 * (`overflow-x: clip` on html, and on body everywhere except this PDP under
 * 750px, where it stays `visible` so the pinned mock's per-frame height writes
 * don't shudder) rather than being written inline from here.
 * Inline was not survivable: any scroll-lock that
 * sets `body.style.overflow = 'hidden'` and clears it with `= ''` — the Recart
 * popup, and eight of our own drawer close handlers — removes the shorthand
 * and takes our overflow-x longhand with it, at which point body falls back to
 * a scroll container and the gallery silently stops sticking for the rest of
 * the page's life. The per-element clips below are kept as belt-and-braces.
 */
(function() {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  var isSurgical = document.documentElement.classList.contains('pdp-surgical-active');

  function fixOverflow() {
    // html/body overflow is stylesheet-owned (custom.css.liquid) — do not set
    // it here. An inline value is erased by the first third-party scroll-lock
    // that resets `body.style.overflow`, and the gallery unsticks with it.
    document.body.style.maxWidth = '100vw';

    // Clip all elements that overflow horizontally
    document.querySelectorAll('marquee-component, slideshow-component, slideshow-slide, .product-media, .mock-image-container, room-background-mock').forEach(function(el) {
      el.style.overflowX = 'clip';
    });

    var mainSection = document.querySelector('.product-information');
    if (mainSection) {
      for (var i = 0; i < mainSection.children.length; i++) {
        var child = mainSection.children[i];
        if (!child.classList.contains('product-information__media') &&
            !child.classList.contains('product-information__grid')) {
          child.style.overflowX = 'clip';
        }
      }
    }

    var grid = document.querySelector('.product-information__grid');
    if (grid) grid.style.overflowX = 'clip';

    document.querySelectorAll('.shopify-section').forEach(function(sec) {
      if (!sec.querySelector('.product-information')) {
        sec.style.overflowX = 'clip';
      }
    });
  }

  function init() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;

    fixOverflow();

    // Surgical PDP: media container is sticky via CSS; skip portal move and slideshow sticky.
    if (isSurgical) return;

    var portal = document.querySelector('collection-portal');
    if (!portal) return;

    // Move portal into the media container (after the gallery)
    media.appendChild(portal);
    // Reset portal margins/width — originally styled for the details column
    portal.style.margin = '0';
    portal.style.width = '100%';
    portal.style.padding = '12px 14px';

    var headerHeight = parseInt(document.body.style.getPropertyValue('--header-height'))
      || parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'))
      || parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
      || 56;

    // The gallery content (slideshow) is sticky within .product-information__media,
    // which now contains both the slideshow and the portal.
    var slideshow = media.querySelector('media-gallery, gallery-wall-media-gallery');
    if (slideshow) {
      slideshow.style.position = 'sticky';
      slideshow.style.top = headerHeight + 'px';
      slideshow.style.zIndex = '3';
      slideshow.style.background = 'var(--color-background, #fff)';

      // Safari loses hit-testing on sticky elements after tab switch.
      // Force a re-composite when the tab becomes visible again.
      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
          slideshow.style.transform = 'translateZ(0)';
          requestAnimationFrame(function() {
            slideshow.style.transform = '';
          });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }
})();
